// Latest News
const latestNewsSlider = document.querySelectorAll('[data-slider="latest-news-slider"]');

const latestNewsSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  autoHeight: true,
  mousewheel: {
    forceToAxis: true,
  },
  breakpoints: {
    767: {
      autoHeight: false,
      slidesPerView: 'auto',
      spaceBetween: 16,
    },
    1199: { autoHeight: false, slidesPerView: 'auto', spaceBetween: 24 },
    1439: { autoHeight: false, slidesPerView: 'auto', spaceBetween: 48 },
  },
};

latestNewsSlider.forEach((el) => new Swiper(el, latestNewsSliderOptions));
